module.exports = __webpack_public_path__ + "static/placeholder.7fa26224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/placeholder.jpg
// module id = 65
// module chunks = 168707334958949